import React from 'react'
import { ModalInformations } from '../ModalComponents/ModalInformations'
import { Physician } from '~/interfaces'
import { replaceStringDashesBy } from '~/utils'

interface ReferringPhysicianDetailsProps {
  physician: Physician
}

export const ReferringPhysicianDetails = ({ physician }: ReferringPhysicianDetailsProps): JSX.Element => {
  const council = `${physician.boardName} ${physician.boardRegistry}/${physician.federativeUnit}`
  return (
    <>
      <ModalInformations label="Profissional solicitante" value={physician.name} />
      <ModalInformations label="Especialidade" value={physician.medicalSpecialty} />
      <ModalInformations label="Telefone(s)" value={replaceStringDashesBy(', ')(physician.phoneContact)} />
      <ModalInformations label="E-mail(s)" value={replaceStringDashesBy(', ')(physician?.emailContact?.join(', '))} />
      <ModalInformations label="Conselho" value={council.length > 2 ? council : ''} />
    </>
  )
}
